import React from "react";
import Tabs from "../../components/common/Tabs";
import { InventoryMenu } from "../../utils/constants";
import { useSelector } from "react-redux";
import AdminSidebarToggle from "../../components/Admin/AdminSidebarToggle";

const Inventory = () => {
  const adminDetails = useSelector((state) => state?.admin?.adminDetails);

  const tabsToRender = adminDetails?.role === "manager"
    ? InventoryMenu.filter(tab => tab.name !== "V Table")
    : InventoryMenu;

  return (
    <>
      <main>
        <div className="flex items-center mb-8 justify-between gap-5">
          <Tabs tabs={tabsToRender} prefix={<AdminSidebarToggle />} />
          {/* <div className="flex items-center justify-between w-full max-w-[500px]">
            <div>Dropdown</div>
            <div>Dropdown</div>
          </div> */}
        </div>
      </main>
    </>
  );
};

export default Inventory;
